<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          page-title="Proceso Acreditación"
          directory="No Conformidades Evaluación"
          :icon="'grid'"
        />
      </div>
      <div class="col-sm-12 col-md-6">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button type="button" class="btn btn-primary btn-with-shadow" @click="
              () => {
                $hub.$emit('reload-table');
              }
            ">
            <i data-feather="refresh-ccw" class="pr-2" /> Refrescar
          </button>
        </div>
      </div>
    </div>
    <div v-if="accApps && accApps.length > 0">
        <div v-for="(value, key) in accApps" :key="key">
          <div class="alert alert-info alert-dismissible fade show h5" role="alert" v-if="value.eval_test_time.remaining_days > 20">
            La no conformidad con el tipo de acreditación  <strong>{{ value.accreditation_applications.accreditation_type.name }}</strong>
            y código <strong>{{ value.code }}</strong>,.
            A partir de la fecha <strong>{{ formatOnlYDate(value.eval_test_time.start_date)  }}</strong> dispone de  {{value.eval_test_time.remaining_days}} días habiles para cumplir el proceso.
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="alert alert-warning alert-dismissible fade show h5" role="alert" v-if="value.eval_test_time.remaining_days <= 20 && value.eval_test_time.remaining_days > 3">
            La no conformidad con el tipo de acreditación  <strong>{{ value.accreditation_applications.accreditation_type.name }}</strong>
            y código <strong>{{ value.code }}</strong>,.
            A partir de la fecha <strong>{{ formatOnlYDate(value.eval_test_time.start_date)  }}</strong> dispone de  {{value.eval_test_time.remaining_days}} días habiles para cumplir el proceso.
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="alert alert-danger alert-dismissible fade show h5" role="alert" v-if="value.eval_test_time.remaining_days <= 3">
            La no conformidad con el tipo de acreditación  <strong>{{ value.accreditation_applications.accreditation_type.name }}</strong>
            y código <strong>{{ value.code }}</strong>,.
            A partir de la fecha <strong>{{ formatOnlYDate(value.eval_test_time.start_date)  }}</strong> dispone de  {{value.eval_test_time.remaining_days}} días habiles para cumplir el proceso.
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
      </div>
    <div class="mb-primary">
      <div class="d-flex justify-content-between mb-3"></div>
      <app-tab :tabs="tabsHorizontal" type="horizontal" />
    </div>
  </div>
</template>

<script>
import CoreLibrary from "@/core/helpers/CoreLibrary.js";
import axios from "axios";
import moment from "moment";

export default {
  extends: CoreLibrary,
  data() {
    return {
      accApps:[],
      tabsHorizontal: [
        {
          icon: "alert-octagon",
          name:
            "Reportar análisis de causa y extensión, correcciones y acciones correctivas",
          component: "report-corrective-actions-table",
          permission: "",
        },
      ],
    };
  },
  created(){
    this.getDataAlerts();
  },
  methods: {
    getDataAlerts(){
      const url = '/accreditations/remainingDaysForAlert';
      axios.get(url)
      .then((response) => {
          this.accApps = response.data;
      })
    },
    formatOnlYDate(strDate){
       return moment(strDate).format('YYYY-MM-DD');
    }
  }
};
</script>
